import { TripFolder } from "@finway-group/shared/lib/models"
import { Rule, RuleObject } from "antd/lib/form"
import moment from "moment"
import { stringRules } from "~Components/forms/rules/common/string.rules"
import i18n from "~Shared/locales/i18n"
import { CompanyService } from "~Shared/services"

const validateTripDateTime = (): RuleObject["validator"] => (_rule, value: moment.Moment) => {
    if (!value) {
        return Promise.reject(new Error(i18n.t("validation:required")))
    }

    return Promise.resolve()
}

export const createTripFolderRules = (_expense: TripFolder) => ({
    returnDate: [
        {
            required: true,
            validator: validateTripDateTime(),
        },
    ] as Array<Rule>,
    returnTime: [
        {
            required: true,
            validator: validateTripDateTime(),
        },
    ] as Array<Rule>,
    tripDate: [
        {
            required: true,
            validator: validateTripDateTime(),
        },
    ] as Array<Rule>,
    tripTime: [
        {
            required: true,
            validator: validateTripDateTime(),
        },
    ] as Array<Rule>,
    folderName: [{ required: true, message: i18n.t("validation:required") }, stringRules.allowedMultiLineCharsOnly] as Array<Rule>,
    destination: [{ required: true, message: i18n.t("validation:required") }, stringRules.allowedMultiLineCharsOnly] as Array<Rule>,
    description: [
        { required: CompanyService.doesCompanyEnforceGobdCompliantInvoice(), message: i18n.t("validation:required") },
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
})
